import * as React from "react";
import { useTranslation } from "react-i18next";
import PageNavigation from "components/common/PageNavigation";
import { Row } from "components/bootstrap";
import useSearchVersionCheck from "hooks/useSearchVersionCheck";
import { Spinner } from "components/common";
import OpenSearchRequiredPage from "security-app/pages/OpenSearchRequiredPage";
import { PAGE_NAV_TITLE } from "security-app/components/Layout/anomalyPageNavigation";
export default function AnomalyLayout({ children }) {
  const { t } = useTranslation("enterprise_security_app");
  const { data: usingOpenSearch, isLoading, error } = useSearchVersionCheck("opensearch");
  if (isLoading) return /* @__PURE__ */ React.createElement(Spinner, null);
  if (error) return /* @__PURE__ */ React.createElement(React.Fragment, null, t("anomaly_layout.error", { message: error.message }));
  if (!usingOpenSearch.satisfied) {
    return /* @__PURE__ */ React.createElement(OpenSearchRequiredPage, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAV_TITLE })), children);
}
